import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import removeKey from "LIB/removeKey";
import { toOptions } from "LIB/forms";
import { QC_STATUSES, UNDER_REVIEW } from "MODULES/inventories/constants";
import { form, Form as AppForm, Select } from "MODULES/shared/components/Forms";
import { update } from "MODULES/inventories/actions";
import validate from "./validate";

function Form(props) {
  const options = removeKey(QC_STATUSES, UNDER_REVIEW);

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Field
          name="qc_status"
          component={Select}
          options={toOptions(options)}
          label="QC Status"
          required
        />
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, { onSubmit: update })(
  form({
    form: "updateInventoryQCStatus",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/UpdateQCStatus/UpdateQCStatusForm.jsx